const ImageTypes =  [
    "jpg", "jpeg", "png"];

const FileTypesInvoice = [
    "jpg", "jpeg", "png", "pdf"
]

export { ImageTypes, FileTypesInvoice }